const formatTimezoneOffset = (offset: number): string => {
  const absoluteOffset = Math.abs(offset);
  const hours = Math.floor(absoluteOffset / 60)
    .toString()
    .padStart(2, "0");
  const minutes = (absoluteOffset % 60).toString().padStart(2, "0");
  const sign = offset <= 0 ? "+" : "-";
  return `${sign}${hours}:${minutes}`;
};

export const getShiftedMinMaxDate = (
  minShift = 0,
  maxShift = 0,
  minYearsShift = 0,
  maxYearsShift = 0,
  startDate?: string,
): { min: string; max: string } => {
  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const offset = date.getTimezoneOffset();
    // const hours = String(date.getHours()).padStart(2, "0")
    // const minutes = String(date.getMinutes()).padStart(2, "0")
    // const seconds = String(date.getSeconds()).padStart(2, "0")
    return `${year}-${month}-${day}T00:00:00${formatTimezoneOffset(offset)}`;
  };

  const today = startDate ? new Date(startDate) : new Date();
  const calculateDate = (daysShift: number, yearsShift: number): Date => {
    const resultDate = new Date(today);
    resultDate.setFullYear(today.getFullYear() + yearsShift);
    resultDate.setDate(resultDate.getDate() + daysShift);
    return resultDate;
  };

  const minDate = calculateDate(minShift, minYearsShift);
  const maxDate = calculateDate(maxShift, maxYearsShift);

  if (minDate > maxDate) {
    return {
      min: formatDate(maxDate),
      max: formatDate(minDate),
    };
  }

  return {
    min: formatDate(minDate),
    max: formatDate(maxDate),
  };
};
